import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { motion, ursaColors } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
var badgeTheme = {
  borderColor: {
    canvas: color("surface--canvas--background"),
    "work-surface": ursaColors.neutral00
  }
};

// This component is not meant to be shipped to consumers.
export var Badge = styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref) {
  var backgroundColor = _ref.backgroundColor,
    size = _ref.size,
    color = _ref.color,
    renderOn = _ref.renderOn;
  return "\n        box-sizing: content-box;\n        border-width: 1px;\n        border-style: solid;\n        border-color: ".concat(badgeTheme.borderColor[renderOn], ";\n        background-color: ").concat(backgroundColor, ";\n        height: ").concat(size, "px;\n        color: ").concat(color, ";\n        font-size: 8px;\n        font-weight: 700;\n        font-family: inherit;\n        line-height: 8px;\n        letter-spacing: -0.2px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        position: absolute;\n        transition: all ").concat(motion.animation.default, ";\n    ");
});
//# sourceMappingURL=Badge.js.map